// Module external access for global module variables
export { sdkContainerInstance } from '../../global/Container';